<div class="verified-content text-center">
<strong *ngIf="responsemsg === true">
    Thank you . Your Email is verified now.
</strong>
<strong *ngIf="responsemsg === false">
    Your Email Address is Not Verified please check your inbox.
</strong>
</div>
